import Moment from 'moment';

export const toAbsoluteUrl = (pathname) => process.env.PUBLIC_URL + pathname;

export const isEmptyOrWhiteSpace = (...list) => {
  let index = 0;
  list.forEach((element) => {
    switch (typeof element) {
      case 'number':
      case 'string':
        if (element.toString().trim() !== '') index = index + 1;
        break;
      case 'object':
        if (element) if (isEmptyOrWhiteSpace(element.toString())) index = index + 1;
        break;
      default:
        return null;
    }
  });
  return index === list.length;
};

export function calcDiffDate(date) {
  let desireDate = new Moment(date),
    diffent = '';
  if (Moment().diff(desireDate, 'years') >= 1) diffent = `${Moment().diff(desireDate, 'years')} years ago`;
  else if (Moment().diff(desireDate, 'months') >= 1) diffent = `${Moment().diff(desireDate, 'months')} months ago`;
  else if (Moment().diff(desireDate, 'weeks') >= 1) diffent = `${Moment().diff(desireDate, 'weeks')} weeks ago`;
  else if (Moment().diff(desireDate, 'days') >= 1) diffent = `${Moment().diff(desireDate, 'days')} days ago`;
  else if (Moment().diff(desireDate, 'hours') >= 1) diffent = `${Moment().diff(desireDate, 'hours')} hours ago`;
  else if (Moment().diff(desireDate, 'minutes') >= 1) diffent = `${Moment().diff(desireDate, 'minutes')} minutes ago`;
  else if (Moment().diff(desireDate, 'minutes') < 1) diffent = `Just now`;

  return diffent;
}

export function requestFormatDate(date) {
  let year = date.getFullYear(),
    month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1,
    day = date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;

  return `${year}-${month}-${day}`;
}

export function startOf(type, date = new Date()) {
  let result;
  switch (type) {
    case 'Day':
      result = new Date();
      break;
    case 'Week':
      let day = date.getDay();
      result = new Date(date.getFullYear(), date.getMonth(), date.getDate() + (day === 0 ? -6 : 1) - day);
      break;
    case 'Month':
      result = new Date(date.getFullYear(), date.getMonth(), 1);
      break;
    case 'Year':
      result = new Date(date.getFullYear(), 0, 1);
      break;
    default:
      result = date;
  }
  return result;
}

export function endOf(type, date = new Date()) {
  let result;
  switch (type) {
    case 'Day':
      result = new Date();
      break;
    case 'Week':
      let day = date.getDay();
      result = new Date(date.getFullYear(), date.getMonth(), date.getDate() + (day === 0 ? 0 : 7) - day);
      break;
    case 'Month':
      result = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      break;
    case 'Year':
      result = new Date(date.getFullYear(), 11, 31);
      break;
    default:
      result = date;
  }
  return result;
}

/**
 * Formats a display name based on fullName and sender
 * @param {string} fullName - The full name of the contact
 * @param {string} sender - The sender identifier (phone number, username, etc.)
 * @returns {string} - Formatted display name
 */
export const formatDisplayName = (fullName, sender) => {
  // If no sender, return fullName or empty string
  if (!sender) {
    return fullName || "";
  }
  
  // If no fullName, format sender based on whether it looks like a phone number
  if (!fullName) {
    // Check if sender looks like a phone number (starts with + or digit, contains digits, spaces, hyphens, parentheses)
    const isPhoneNumber = /^\+?\d[\d\s\-()]+$/.test(sender);
    
    if (isPhoneNumber) {
      // If it already has parentheses, use as is, otherwise wrap in parentheses
      const hasParentheses = /\(.*\)/.test(sender);
      return hasParentheses ? sender : `(${sender})`;
    } else {
      // Not a phone number, use sender as is
      return sender;
    }
  }
  
  // Both fullName and sender exist
  // Check if sender looks like a phone number
  const isPhoneNumber = /^\+?\d[\d\s\-()]+$/.test(sender);
  
  if (isPhoneNumber) {
    // If sender already has parentheses, use as is, otherwise wrap in parentheses
    const hasParentheses = /\(.*\)/.test(sender);
    const formattedSender = hasParentheses ? sender : `(${sender})`;
    return `${fullName} ${formattedSender}`;
  } else {
    // Not a phone number, show as fullName (sender)
    return `${fullName} (${sender})`;
  }
};

// Alternative shorter version (same logic as your original template string)
export const formatDisplayNameCompact = (fullName, sender) => {
  return `${fullName ? fullName : ""} ${sender ? fullName ? `(${sender})` : /^\+?\d[\d\s\-()]+$/.test(sender) ? /\(.*\)/.test(sender) ? sender : `(${sender})` : sender : ""}`.trim();
};

// Usage examples:
// formatDisplayName("John Doe", "+1234567890") → "John Doe (+1234567890)"
// formatDisplayName("John Doe", "john123") → "John Doe (john123)"
// formatDisplayName("", "+1234567890") → "(+1234567890)"
// formatDisplayName("", "john123") → "john123"
// formatDisplayName("John Doe", "") → "John Doe"